import { db } from "@/integrations/firebase/client";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";

export interface LeadData {
    name: string;
    email: string;
    company: string;
    message?: string;
    plan: string;
}

export const saveLead = async (leadData: LeadData) => {
    try {
        const docRef = await addDoc(collection(db, "leads"), {
            ...leadData,
            createdAt: serverTimestamp(),
            status: "new", // Initial status for the lead
        });
        console.log("Lead saved with ID: ", docRef.id);

        // Trigger email notification
        await addDoc(collection(db, "mail"), {
            to: "james@hiapply.co",
            message: {
                subject: `New Lead: ${leadData.name} (${leadData.plan})`,
                text: `Name: ${leadData.name}\nEmail: ${leadData.email}\nCompany: ${leadData.company}\nPlan: ${leadData.plan}\nMessage: ${leadData.message || "N/A"}`,
                html: `
                    <h1>New Lead Captured</h1>
                    <p><strong>Name:</strong> ${leadData.name}</p>
                    <p><strong>Email:</strong> ${leadData.email}</p>
                    <p><strong>Company:</strong> ${leadData.company}</p>
                    <p><strong>Plan:</strong> ${leadData.plan}</p>
                    <p><strong>Message:</strong> ${leadData.message || "N/A"}</p>
                `,
            },
        });

        return { success: true, id: docRef.id };
    } catch (error) {
        console.error("Error adding lead: ", error);
        return { success: false, error };
    }
};
